import axios from "axios";
import { getCsrfToken } from "./utils";

export const index = async () => {
  const request = {
    url: "/actions/commerce/cart/get-cart",
  };

  const response = await axios(request);
  return response.data.cart;
};

export const addItem = async ({ purchasable, quantity, options }) => {
  let data = {
    purchasableId: purchasable.id,
    qty: quantity,
    validateAddress: false,
    ...getCsrfToken(),
  };

  if (options) {
    data = { ...data, options };
  }

  const request = {
    url: "/actions/commerce/cart/update-cart",
    method: "post",
    data,
  };

  const response = await axios(request);

  if (response.data.errors) {
    Object.entries(response.data.errors).forEach((error) => {
      const msg = error[1][0];

      if (msg.toUpperCase().endsWith("IS CURRENTLY OUT OF STOCK.")) {
        throw new Error("That item is currently out of stock");
      }
      throw new Error(msg.replace(".", ""));
    });
    throw new Error("Operation failed");
  }

  return response.data.cart;
};

export const removeItem = async (item) => {
  const request = {
    url: "/actions/commerce/cart/update-cart",
    method: "post",
    data: {
      lineItems: { [item.id]: { remove: "1" } },
      validateAddress: false,
      ...getCsrfToken(),
    },
  };

  const response = await axios(request);

  if (!(response.status === 200)) throw new Error("Operation failed");

  return response.data.cart;
};

export const changeItemQuantity = async ({ item, qty }) => {
  const request = {
    url: "/actions/commerce/cart/update-cart",
    method: "post",
    data: {
      lineItems: { [item.id]: { qty } },
      clearNotices: true,
      validateAddress: false,
      ...getCsrfToken(),
    },
  };

  const response = await axios(request);

  return response.data;
};

export const updateCart = async (data) => {
  const request = {
    url: "/actions/commerce/cart/update-cart",
    method: "post",
    data: {
      ...data,
      clearNotices: true,
      validateAddress: false,
      ...getCsrfToken(),
    },
  };

  const response = await axios(request);

  if (response.data.errors) throw new Error("Operation failed");

  return response.data.cart;
};

export const getVoucherCodes = async () => {
  const request = {
    url: "/api/voucher-codes",
    method: "get",
  };

  const response = await axios(request);

  return response.data;
};

export const addVoucherCode = async (voucherCode) => {
  const request = {
    url: "/actions/gift-voucher/cart/add-code",
    method: "post",
    data: {
      voucherCode,
      ...getCsrfToken(),
    },
  };

  const response = await axios(request);

  return response.data;
};

export const removeVoucherCode = async (voucherCode) => {
  const request = {
    url: "/actions/gift-voucher/cart/remove-code",
    method: "post",
    data: {
      voucherCode,
      ...getCsrfToken(),
    },
  };

  const response = await axios(request);

  return response.data;
};
